var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.1663C16.3536 19.1663 16.6928 19.0259 16.9428 18.7758C17.1929 18.5258 17.3333 18.1866 17.3333 17.833V9.83301L13.3333 5.83301H8C7.64638 5.83301 7.30724 5.97348 7.05719 6.22353C6.80714 6.47358 6.66666 6.81272 6.66666 7.16634V17.833C6.66666 18.1866 6.80714 18.5258 7.05719 18.7758C7.30724 19.0259 7.64638 19.1663 8 19.1663H16ZM12.6667 7.16634L16 10.4997H12.6667V7.16634ZM8.66666 9.83301H10.6667V11.1663H8.66666V9.83301ZM8.66666 12.4997H15.3333V13.833H8.66666V12.4997ZM8.66666 15.1663H15.3333V16.4997H8.66666V15.1663Z",
    fill: "#040815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsBlack);
export default __webpack_public_path__ + "static/media/Reports-Black.bd4bf3045b1996d8982563e8e5c6b7ae.svg";
export { ForwardRef as ReactComponent };